import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { IconX, IconPlus } from '@tabler/icons';

import { Button, HideMobile, Separator } from 'src/UIComponents';
import SomethingsList from 'src/Components/Something/SomethingsList';
import SomethingDetails from 'src/Components/Something/SomethingDetails';
import SomethingEdit from 'src/Components/Something/SomethingEdit';
import { useToggle } from 'src/hooks';

import AnythingQuickAdd from 'src/Components/Anything/AnythingQuickAdd';

const Actions = styled.div`
  float: right;
  text-align: right;
`;

export function SomethingsView({ ...rest }) {
  return (
    <div {...rest}>
      <SomethingsList />
    </div>
  );
}

export function SomethingView(props) {
  const { id } = useParams();
  const [showAnythingBar, toggleAnythingBar] = useToggle(false);

  return (
    <div {...props}>
      <Actions>
        <Button
          size="small"
          outline
          $color={showAnythingBar && 'danger'}
          onClick={toggleAnythingBar}
        >
          {showAnythingBar ? (
            <IconX />
          ) : (
            <>
              <IconPlus />
              <HideMobile>Anything</HideMobile>
            </>
          )}
        </Button>
      </Actions>
      {showAnythingBar && (
        <div>
          <AnythingQuickAdd somethingId={id} />
          <Separator />
        </div>
      )}
      <SomethingDetails id={id} />
    </div>
  );
}

export function SomethingEditView(props) {
  const { id } = useParams();

  return (
    <div {...props}>
      <h1>Edit Something</h1>
      <SomethingEdit id={id} />
    </div>
  );
}
